<template>
    <div class="page-freight-setting">
        <div class="pg-breadcrumb">
            <div class="breadcrumb-item em">客服專區</div>
            <div class="breadcrumb-item">問題反饋</div>
        </div>

        <div class="card-block pd-bt">
			<Spin fix class="pg-sub-loading" v-if="isLoading">
			    <Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
			    <div class="loading-text">Loading</div>
			</Spin>
			
            <Table size="small"
                   border
                   no-data-text="暫無數據"
                   :columns="table.column"
                   :data="table.data">
                <template slot-scope="{ row, index }" slot="img">
                    <!-- <div class="table-img-wrap">
                        <Avatar v-for="(row, index) in row.images" :src="row.image_path" ></Avatar>
                    </div> -->
                    <div class="demo-image__preview" @click="handlesrcList(row.images)">
                        <el-image 
                            v-for="(row, index) in row.images"
                            style="width: 35px; height: 50px"
                            :src="row.image_path"
                            :key="row.id"
                            :preview-src-list="srcList">
                        </el-image>
                    </div>
                </template>

                <template slot-scope="{ row, index }" slot="action">
                    <div class="pg-btn-wrap">
                        <div class="pg-btn style2" @click="handleFeedBackEdit(index)">回覆</div>
                    </div>
                </template>
            </Table>

            <div class="pg-pagger">
                <Row>
                    <Col span="12" class="pagger-left">
                        <div class="pagger-total">總共{{totalCount}}條記錄</div>
                    </Col>
                    <Col span="12" class="pagger-right">
                        <!-- v-if="totalCount > curPageSize" -->
                        <div>
                            <div class="pagger-sizer">
                                <span>每頁</span>
                                <Select v-model="curPageSize" size="small" placeholder="數量"
                                        @on-change="handlePageSizeChange">
                                    <Option :value="10">10</Option>
                                    <Option :value="20">20</Option>
                                    <Option :value="30">30</Option>
                                    <Option :value="40">40</Option>
                                    <Option :value="50">50</Option>
                                </Select>
                            </div>

                            <div class="pagger-elevator">
                                <span>跳轉</span>
                                <Input size="small" v-model="pageInput" @on-keyup="handlePageInput"
                                       @on-enter="handlePageEnter"/>
                            </div>

                            <Page size="small"
                                  :current="pageIndex"
                                  :page-size="curPageSize"
                                  :total="totalCount"
                                  @on-change="handlePageChange">
                            </Page>
                        </div>
                    </Col>
                </Row>
            </div>

        </div>

    </div>
</template>

<script>
    export default {
        data()
        {
            return {
                srcList: [],
                pageIndex: 1,
                curPageSize: 10,
                totalCount: 1,
                pageInput: '',
                isLoading: true,
                table: {
                    column: [
                        {
                            title: '創單時間',
                            key: 'created_at',
                            align: 'center',
							sortable: true,
                            minWidth: 40
                        },
                        {
                            title: '快遞單號',
                            key: 'order',
                            align: 'center',
                            sortable: true,
                            minWidth: 40
                        },
                        {
                            title: '聯絡方式',
                            key: 'contact',
                            align: 'center',
							sortable: true,
                            minWidth: 30
                        },
                        {
                            title: '問題描述',
                            key: 'content',
                            align: 'center',
							sortable: true,
                            minWidth: 400
                        },
                        {
                            title: '圖片',
                            key: 'images',
                            align: 'center',
                            slot: 'img',
                            sortable: true,
                            minWidth: 200
                        },
                        {
                            title: '處理狀態',
                            key: 'status',
                            align: 'center',
							sortable: true,
                            minWidth: 20
                        },
                        {
                            title: '處理操作人',
                            key: 'handle_user',
                            align: 'center',
                            sortable: true,
                            minWidth: 20
                        },
                        {
                            title: '操作',
                            slot: 'action',
                            align: 'center',
                            minWidth: 20
                        }
                    ],
                    data: []
                }
            };
        },
		mounted()
        {
            this.getList();
        },
        activated()
        {
            this.getList();
        },
        methods: {
            handlesrcList(imgobj){
                this.srcList = [];
                for (let i = 0; i < imgobj.length; i++)
                {
                    this.srcList.push(imgobj[i].image_path);
                }
            },
            getList()
            {
                let form = this.form;
                this.isLoading = true;
                this.$Rq.requestAuth({
                    url: this.$Api.feedBack,
                    method: 'get',
                    data: {
                        offset: (this.pageIndex - 1) * this.curPageSize,
                        limit: this.curPageSize
                    }
                }).then((res) =>
                {
                    this.isLoading = false;
                    if (res.code == 0)
                    {
                        let tempArr = [];
                        let resData = res.data.data;

                        for (let i = 0; i < resData.length; i++)
                        {
                            tempArr.push({
								id: resData[i].id,
                                contact: resData[i].contact == null ? '- - -' : resData[i].contact,
								content: resData[i].content == '' ? '- - -' : resData[i].content,
								created_at: resData[i].created_at,
                                order: resData[i].order,
                                status: resData[i].status == 0 ? '未回覆' : '已回覆',
                                handle_user: resData[i].handle_user == 0 ? '- - -' : resData[i].handle_user,
                                images: resData[i].images == '' ? '- - -' : resData[i].images,
                            });
                        }
                        this.totalCount = res.data.count;
                        this.table.data = tempArr;
                    }
                }).catch(() =>
                {
                    this.isLoading = false;
                });
            },
            handleFeedBackEdit(index)
            {
                let tableData = this.table.data;
                this.$router.push({path: '/feedbackedit?id=' + tableData[index].id});
            },
            //pager
            handlePageSizeChange(value)
            {
                this.pageIndex = 1;
                this.getList();
            },
            handlePageInput()
            {
                let value = ('' + this.pageInput).replace(/\D/g, '');
                let pageCount = Math.ceil(this.totalCount / this.curPageSize);
                if (value > pageCount)
                {
                    value = pageCount;
                }
                this.pageInput = value;
            },
            handlePageEnter()
            {
                if (this.pageInput == '' || this.pageInput == this.pageIndex) return;
                if (this.pageInput == 0)
                {
                    this.pageInput = 1;
                }
                this.pageInput = parseInt(this.pageInput);
                this.pageIndex = this.pageInput;
                this.getList();
            },

            handlePageChange(value)
            {
                this.pageIndex = value;
                this.getList();
            }
        }
    };
</script>

<style lang="scss" scoped>
    @import 'feedback.scss';
</style>